import React from "react";
import { Alert, Box, FormControl, FormLabel, Select, MenuItem } from "@mui/material";
import type { ScorecardWeightSelection } from "@/models/Scorecard";

interface FormattingSectionProps {
  weight: ScorecardWeightSelection;
  weightsApplied: boolean;
  percentageFormatting: 0 | 1 | 2;
  meanFormatting: 0 | 1 | 2;
  onWeightChange: (value: ScorecardWeightSelection) => void;
  onPercentageFormattingChange: (value: 0 | 1 | 2) => void;
  onMeanFormattingChange: (value: 0 | 1 | 2) => void;
}

const FormattingSection: React.FC<FormattingSectionProps> = ({
  weight,
  weightsApplied,
  percentageFormatting,
  meanFormatting,
  onWeightChange,
  onPercentageFormattingChange,
  onMeanFormattingChange,
}) => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <FormControl fullWidth size="small">
        <FormLabel className="text-[12px] text-[#262626]">Weight</FormLabel>
        <Select
          value={weight}
          onChange={(e) => onWeightChange(e.target.value as ScorecardWeightSelection)}
        >
          <MenuItem value="DISABLED">Disabled</MenuItem>
          <MenuItem value="DATASET_DEFAULT">Use Default Weight</MenuItem>
        </Select>
      </FormControl>

      {weight === "DISABLED" && (
        <Alert severity="info" sx={{ py: 0.5 }}>
          Weights disabled: unweighted counts shown.
        </Alert>
      )}
      {weight === "DATASET_DEFAULT" && !weightsApplied && (
        <Alert severity="warning" sx={{ py: 0.5 }}>
          This dataset has no default weight configured.
        </Alert>
      )}

      <FormControl fullWidth size="small">
        <FormLabel className="text-[12px] text-[#262626]">
          Percentage rounding
        </FormLabel>
        <Select
          value={percentageFormatting}
          onChange={(e) => onPercentageFormattingChange(e.target.value as 0 | 1 | 2)}
        >
          <MenuItem value={0}>0 decimals</MenuItem>
          <MenuItem value={1}>1 decimal</MenuItem>
          <MenuItem value={2}>2 decimals</MenuItem>
        </Select>
      </FormControl>

      <FormControl fullWidth size="small">
        <FormLabel className="text-[12px] text-[#262626]">Mean rounding</FormLabel>
        <Select
          value={meanFormatting}
          onChange={(e) => onMeanFormattingChange(e.target.value as 0 | 1 | 2)}
        >
          <MenuItem value={0}>0 decimals</MenuItem>
          <MenuItem value={1}>1 decimal</MenuItem>
          <MenuItem value={2}>2 decimals</MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
};

export default FormattingSection;
